// ----------------- CONFIG (test values) -----------------
// For PROD:
export const IDLE_LIMIT_MS = 30 * 60 * 1000;      // 30 minutes
export const IDLE_POPUP_GRACE_MS = 5 * 60 * 1000; // 5 minutes
export const ABSOLUTE_LIMIT_MS = 10 * 60 * 60 * 1000; // 10 hours
export const ABSOLUTE_WARNING_BEFORE_MS = 5 * 60 * 1000; // 5 minutes warning
export const RENEW_BUFFER_SEC = 10 * 60; // 10 minutes before expiry
//  export const RENEW_BUFFER_SEC = 3300;//50 minutes 


// For testing dev
// export const IDLE_LIMIT_MS = 5 * 60 * 1000;           // 5 minutes for testing
// export const IDLE_POPUP_GRACE_MS = 2 * 60 * 1000;     // 2 minute for testing
// export const ABSOLUTE_LIMIT_MS = 15 * 60 * 1000;      // 15 minutes for testing
// export const ABSOLUTE_WARNING_BEFORE_MS = 5 * 60 * 1000; // 5 minutes warning
// export const RENEW_BUFFER_SEC = 3300;//50 minutes 

// For testing QA
// export const IDLE_LIMIT_MS = 10 * 60 * 1000;      // 10 minutes
// export const IDLE_POPUP_GRACE_MS = 5 * 60 * 1000; // 5 minutes
// export const ABSOLUTE_LIMIT_MS = 45 * 60 * 1000;      // 45 minutes for testing
// export const ABSOLUTE_WARNING_BEFORE_MS = 5 * 60 * 1000; // 5 minutes warning

export const SESSION_START_KEY = 'SESSION_START_TIME';
export const LAST_ACTIVITY_KEY = 'LAST_ACTIVITY_TIME';
export const LOGOUT_BROADCAST_KEY = 'LOGOUT_BROADCAST';
export const LOGOUT_MULTI_TAB_KEY = 'LOGOUT_MULTI_TAB_KEY';

